import React, {useState, useEffect, useContext} from 'react'
import {ContenedorTituloResaltado} from '../Contenedores'
import {Controller, useForm} from 'react-hook-form'
import {BotonConImagen, BotonSimple, BotonTextoImagenAlFinal} from '../Botones'
import BotonAgregar from '../../imagenes/addButton.png'
import {AlertaDinamica, NumeroConTitulo} from '../MostrarEnPantalla'
import {aplicarFormatoMoneda} from '../../utils'
import {ListaDesplegable, Input} from '../inputs'
import {
  IconoAgregarAlCarrito,
  IconoServicioEnCarrito,
  BotonQuitar,
} from '../../imagenes'
import {LeyendaConInputRadio} from '../Leyendas'
import {
  ObtenerCiudadPorId,
  ObtenerTodasLasSedes,
} from '../../cache/servicios-cache'
import TablaDinamica from '../TablaDinamica'
import CeldaConBoton from '../Ordenes/CeldaConBoton'
import {ObtenerOtrosServicios} from '../../microservicios/OtrosServicios'
import {TIPOS_OTROS_SERVICIOS} from '../../constantes'
import {CIUDAD_ID, SEDE_ID} from '../../constantes'
import clsx from 'clsx'
import {ObtenerConfiguracionPorParticion} from '../../microservicios'
import {ContextoAplicacion} from '../../contexto'
import {appRegex} from '../../utils/utilidades.app'

const PagarOtrosServicios = ({funcionCambiarDePantalla}) => {
  const contextoAplicacion = useContext(ContextoAplicacion)

  const servicioSeleccionadoPorDefecto = {
    nombreServicio: '',
    valorUnidad: 0,
    valorTotal: 0,
    cantidad: 0,
    iva: 0,
    ivaCalculado: 0,
    tipoServicio: '',
    id: '',
    numeroDeServicios: 0,
  }

  const datosTiqueterasPorDefecto = {
    nombreDeQuienRecibe: '',
    ciudadId: '',
    barrio: '',
    direccion: '',
    telefono: '',
    envioDomicilio: true,
  }
  const sedePorDefecto = {
    ciudadId: '',
    nombreSede: '',
    direccion: '',
    sedeId: '',
  }

  const {
    control,
    trigger,
    setValue,
    formState: {isValid},
    reset,
  } = useForm({
    mode: 'all',
    defaultValues: {},
  })

  const [servicioSeleccionado, setServicioSeleccionado] = useState(
    servicioSeleccionadoPorDefecto
  )
  const [cantidadServicios, setCantidadServicios] = useState('')

  const [radialSeleccionado, setRadialSeleccionado] = useState(true)

  const [todasLasSedes, setTodasLasSedes] = useState([])

  const [sedeSeleccionada, setSedeSeleccionada] = useState(sedePorDefecto)

  const [datosTablaServicios, setDatosTablaServicios] = useState([])

  const [valoresTabla, setValoresTabla] = useState({
    totalServicios: 0,
    totalIva: 0,
    totalTransaccion: 0,
  })
  const [listaDeServicios, setListaDeServicios] = useState([])

  const [datosTiqueteras, setDatosTiqueteras] = useState(
    datosTiqueterasPorDefecto
  )

  const [ciudadesEnviarADomicilio, setCiudadesEnviarADomicilio] = useState([])

  const [ciudadesRecogerEnSede, setCiudadesRecogerEnSede] = useState([])

  const [nombreCiudades, setNombreCiudades] = useState([])

  useEffect(() => {
    const obtenerDatosServicios = async () => {
      try {
        const respuesta = await ObtenerOtrosServicios()
        if (respuesta.status === 200) {
          setListaDeServicios(
            respuesta?.data?.map((servicio) => {
              return {
                Id: servicio?.id,
                Nombre: `${servicio?.nombre}${
                  servicio.cantidad > 1 ? ` x ${servicio.cantidad}` : ''
                }`.toUpperCase(),
                TipoServicio: servicio?.tipoServicioId,
                Precio:
                  servicio?.tipoServicioId === +TIPOS_OTROS_SERVICIOS.TIQUETERA
                    ? servicio?.preciosCiudades
                    : servicio?.valor,
                Cantidad: servicio?.cantidad,
                Iva:
                  servicio?.tipoServicioId?.toString() ===
                  TIPOS_OTROS_SERVICIOS.TIQUETERA
                    ? 0
                    : servicio?.iva,
                Rangos: servicio?.rangos,
              }
            })
          )
        }
      } catch (error) {
        console.log(error)
      }
    }
    obtenerDatosServicios()
  }, [])

  const filtrarSedes = (datos, datosSedes) => {
    return datos.filter((sede) => {
      if (
        sede.CiudadId === CIUDAD_ID.MEDELLIN &&
        sede.Id === datosSedes.MEDELLIN_AGUACATALA
      )
        return true
      if (
        sede.CiudadId === CIUDAD_ID.BOGOTA &&
        sede.Id === datosSedes.BOGOTA_PRINCIPAL
      )
        return true
      if (
        sede.CiudadId === CIUDAD_ID.CALI &&
        sede.Id === datosSedes.CALI_VERSALLES
      )
        return true
      if (
        sede.Nombre?.toUpperCase().includes('ALIADO') ||
        sede.Nombre?.toUpperCase().includes('BRIGADA')
      )
        return false
      return ![CIUDAD_ID.MEDELLIN, CIUDAD_ID.BOGOTA, CIUDAD_ID.CALI].includes(
        sede.CiudadId
      )
    })
  }

  const cerrarModal = () => {
    contextoAplicacion.setModal({abierto: false, botones: []})
  }

  useEffect(() => {
    const obtenerSedes = async () => {
      try {
        const sedes = await ObtenerTodasLasSedes()
        const sedesTableStorage = await ObtenerConfiguracionPorParticion(
          'SedesPagarOtrosServiciosPortalCliente'
        )
        if (sedesTableStorage.status === 200) {
          let datosParseados = JSON.parse(
            sedesTableStorage.data
              .trim()
              .replace(/,\s*}/, '}')
              .replace(/(\w+):/g, '"$1":')
          )
          const sedesFiltradas = filtrarSedes(sedes, datosParseados)
          setTodasLasSedes(
            sedesFiltradas.map((sede) => {
              return {
                ...sede,
                Id: sede.CiudadId,
                SedeId: sede.Id,
                Nombre: sede.Nombre,
                Direccion: `CENDIATRA ${sede.Nombre} - ${sede.Direccion}`,
                valor: servicioSeleccionado?.preciosCiudades.find((ciudad) => {
                  return ciudad?.ciudadId === sede.CiudadId
                })?.valor,
              }
            })
          )

          const habilitarRecogerEnSede = servicioSeleccionado.preciosCiudades
            .filter((precio) => precio.esRecogidaEnSede)
            .map((precio) => precio.ciudadId)

          const habilitarEnviarADomicilio = servicioSeleccionado.preciosCiudades
            .filter((precio) => precio.esEnvioDomicilio)
            .map((precio) => precio.ciudadId)

          const sedesParaRecogerEnSede = sedesFiltradas.filter((sede) =>
            habilitarRecogerEnSede.includes(sede.CiudadId)
          )

          const sedesParaEnviarADomicilio = sedesFiltradas.filter((sede) =>
            habilitarEnviarADomicilio.includes(sede.CiudadId)
          )

          if (datosTiqueteras.ciudadId) {
            const ciudadId = +datosTiqueteras.ciudadId

            const envioDomicilio = datosTiqueteras.envioDomicilio

            const mismoTipoEnvio = envioDomicilio
              ? habilitarEnviarADomicilio.length
              : habilitarRecogerEnSede.length

            if (!mismoTipoEnvio) {
              setServicioSeleccionado(servicioSeleccionadoPorDefecto)
              contextoAplicacion.setModal({
                abierto: true,
                titulo: 'Señor Usuario',
                contenido: (
                  <div className="w-full flex justify-center items-center text-cendiatra text-3xl my-10 font-bold flex-wrap">
                    <span className="w-full">
                      {`Esta tiquetera no está habilitada para ${
                        envioDomicilio
                          ? 'para enviar a domicilio.'
                          : 'entrega en sede.'
                      }`}
                    </span>
                  </div>
                ),
                botones: [
                  {
                    nombre: 'Regresar',
                    click: () => cerrarModal(),
                  },
                ],
              })
              return
            }

            const existeCiudad = envioDomicilio
              ? habilitarEnviarADomicilio.includes(ciudadId)
              : habilitarRecogerEnSede.includes(ciudadId)

            if (!existeCiudad) {
              setServicioSeleccionado(servicioSeleccionadoPorDefecto)
              const ciudad = await ObtenerCiudadPorId(+ciudadId)
              contextoAplicacion.setModal({
                abierto: true,
                titulo: 'Señor Usuario',
                contenido: (
                  <div className="w-full flex justify-center items-center text-cendiatra text-3xl my-10 font-bold flex-wrap">
                    <span className="w-full">
                      {`Esta tiquetera no está habilitada para la ciudad ${ciudad?.Nombre}`}
                    </span>
                  </div>
                ),
                botones: [
                  {
                    nombre: 'Regresar',
                    click: () => cerrarModal(),
                  },
                ],
              })

              return
            }
          }
          setCiudadesRecogerEnSede(
            await Promise.all(
              sedesParaRecogerEnSede.map(async (sede) => {
                const infoCiudad = await ObtenerCiudadPorId(sede.CiudadId)
                return {
                  ...sede,
                  Id: sede.CiudadId,
                  SedeId: sede.Id,
                  Nombre: infoCiudad?.Nombre,
                  Direccion: `CENDIATRA ${sede.Nombre} - ${sede.Direccion}`,
                  Valor: servicioSeleccionado?.preciosCiudades.find(
                    (ciudad) => {
                      return ciudad?.ciudadId === sede.CiudadId
                    }
                  )?.valor,
                }
              })
            )
          )

          setCiudadesEnviarADomicilio(
            await Promise.all(
              sedesParaEnviarADomicilio.map(async (sede) => {
                const infoCiudad = await ObtenerCiudadPorId(sede.CiudadId)
                return {
                  ...sede,
                  Id: sede.CiudadId,
                  SedeId: sede.Id,
                  Nombre: infoCiudad?.Nombre,
                  Valor: servicioSeleccionado?.preciosCiudades.find(
                    (ciudad) => {
                      return ciudad?.ciudadId === sede.CiudadId
                    }
                  )?.valor,
                }
              })
            )
          )
        }
      } catch (error) {
        console.log(error)
      }
    }
    if (
      servicioSeleccionado.tipoServicio === +TIPOS_OTROS_SERVICIOS.TIQUETERA
    ) {
      obtenerSedes()
    }
  }, [servicioSeleccionado?.id])

  useEffect(() => {
    const capitalizar = (nombre) => {
      return nombre.charAt(0).toUpperCase() + nombre.slice(1).toLowerCase()
    }
    const nombreCiudadesEnviarADomicilio = ciudadesEnviarADomicilio.map(
      (ciudad) => ciudad.Nombre
    )
    const ciudadesFormateadas = nombreCiudadesEnviarADomicilio.map(capitalizar)
    setNombreCiudades(ciudadesFormateadas)
  }, [ciudadesEnviarADomicilio])

  useEffect(() => {
    if (datosTiqueteras?.ciudadId) {
      const ciudadSeleccionada = todasLasSedes.find((ciudad) => {
        return ciudad.Id === +datosTiqueteras?.ciudadId
      })
      setServicioSeleccionado((prev) => {
        return {
          ...prev,
          valorUnidad: ciudadSeleccionada?.valor,
          valorTotal: ciudadSeleccionada?.valor * (cantidadServicios || 1),
        }
      })
    }
  }, [datosTiqueteras, ciudadesRecogerEnSede, ciudadesEnviarADomicilio])

  useEffect(() => {
    setServicioSeleccionado((prev) => {
      return {
        ...prev,
        valorTotal:
          parseFloat(prev?.valorUnidad) * parseFloat(cantidadServicios || 1),
      }
    })
  }, [cantidadServicios])

  const manejarExamenSeleccionado = (servicioId) => {
    setServicioSeleccionado(servicioSeleccionadoPorDefecto)
    setCantidadServicios('')
    if (servicioId) {
      const servicioSeleccionado = listaDeServicios?.find(
        (elemento) => elemento.Id == servicioId
      )
      const valorInicialRangos = obtenerValorPorCantidad(
        1,
        servicioSeleccionado?.Rangos
      )
      if (
        servicioSeleccionado?.TipoServicio === +TIPOS_OTROS_SERVICIOS.TIQUETERA
      ) {
        const tieneEnvioODomicilioOSede = servicioSeleccionado?.Precio?.some(
          (item) =>
            item.esEnvioDomicilio === true || item.esRecogidaEnSede === true
        )

        if (!tieneEnvioODomicilioOSede) {
          setServicioSeleccionado(servicioSeleccionadoPorDefecto)
          return contextoAplicacion.setModal({
            abierto: true,
            titulo: 'Señor Usuario',
            contenido: (
              <div className="w-full flex justify-center items-center text-cendiatra text-3xl my-10 font-bold flex-wrap">
                <span className="w-full">
                  Esta tiquetera no está habilitada para enviar a domicilio o
                  para entrega en sede.
                </span>
              </div>
            ),
            botones: [
              {
                nombre: 'Regresar',
                click: () => cerrarModal(),
              },
            ],
          })
        }
      }

      return setServicioSeleccionado({
        nombreServicio: servicioSeleccionado?.Nombre,
        valorUnidad:
          servicioSeleccionado?.TipoServicio ===
          +TIPOS_OTROS_SERVICIOS.TIQUETERA
            ? 0
            : servicioSeleccionado?.Precio || valorInicialRangos,
        valorTotal:
          servicioSeleccionado?.TipoServicio ===
          +TIPOS_OTROS_SERVICIOS.TIQUETERA
            ? 0
            : servicioSeleccionado?.Precio || valorInicialRangos,
        preciosCiudades:
          servicioSeleccionado?.TipoServicio ===
          +TIPOS_OTROS_SERVICIOS.TIQUETERA
            ? servicioSeleccionado?.Precio
            : [],
        iva: servicioSeleccionado?.Iva,
        ivaCalculado: servicioSeleccionado?.Iva
          ? calcularIva(
              parseFloat(servicioSeleccionado?.Precio || valorInicialRangos),
              parseFloat(servicioSeleccionado?.Iva)
            )
          : 0,
        numeroDeServicios: 1,
        cantidad: servicioSeleccionado.Cantidad,
        tipoServicio: servicioSeleccionado?.TipoServicio,
        id: servicioSeleccionado?.Id,
        rangos: servicioSeleccionado?.Rangos,
      })
    }

    return setServicioSeleccionado(servicioSeleccionadoPorDefecto)
  }

  useEffect(() => {
    trigger()
  }, [servicioSeleccionado, radialSeleccionado])

  useEffect(() => {
    if (!datosTablaServicios.length) {
      setRadialSeleccionado(
        ciudadesEnviarADomicilio.length || !ciudadesRecogerEnSede.length
      )
      setSedeSeleccionada(sedePorDefecto)
      setDatosTiqueteras((prev) => {
        return {
          ...prev,
          envioDomicilio:
            ciudadesEnviarADomicilio.length || !ciudadesRecogerEnSede.length,
        }
      })
    }
  }, [ciudadesEnviarADomicilio, ciudadesRecogerEnSede])

  const obtenerValorPorCantidad = (cantidad, rangos) => {
    const valorPrimerRango = rangos[0]?.valor
    for (const rango of rangos) {
      if (!rango.rangoMaximo && cantidad >= rango.rangoMinimo) {
        return rango.valor
      } else if (
        cantidad >= rango.rangoMinimo &&
        cantidad <= rango.rangoMaximo
      ) {
        return rango.valor
      }
    }
    return valorPrimerRango
  }

  const resetearValoresTiquetera = () => {
    setDatosTiqueteras((prev) => {
      return {
        ...prev,
        ciudadId: '',
      }
    })
    setSedeSeleccionada(sedePorDefecto)
    setValue('ciudadId', '')
  }

  const manejarCantidadDeServicios = (cantidad) => {
    setCantidadServicios(cantidad.target.value)
    const valorRango = obtenerValorPorCantidad(
      cantidad.target.value,
      servicioSeleccionado?.rangos
    )

    agregarValoresPropiedad(cantidad.target.value, 'numeroDeServicios')

    setServicioSeleccionado((prev) => {
      return {
        ...prev,
        valorUnidad: valorRango || prev?.valorUnidad,
        valorTotal: valorRango || prev?.valorTotal,
        ivaCalculado: prev?.iva
          ? calcularIva(
              parseFloat(valorRango || prev?.valorUnidad) *
                parseFloat(cantidad.target.value || 1),
              parseFloat(prev?.iva)
            )
          : 0,
      }
    })
  }

  const cambiarInputRadial = () => {
    if (validarExistenciaTiqueterasCarrito()) return

    resetearValoresTiquetera()
    setRadialSeleccionado((prev) => {
      const nuevoRadialSeleccionado = !prev
      agregarValoresTiquetera(nuevoRadialSeleccionado, 'envioDomicilio')
      return nuevoRadialSeleccionado
    })

    setServicioSeleccionado((prev) => {
      return {
        ...prev,
        valorUnidad: 0,
        valorTotal: 0,
      }
    })
  }

  const manejarSedeSeleccionada = (ciudadId, esEnviar = false) => {
    agregarValoresTiquetera(ciudadId, 'ciudadId')
    if (ciudadId) {
      const sedeSeleccionada = todasLasSedes?.find(
        (elemento) => elemento.Id === +ciudadId
      )

      setSedeSeleccionada({
        id: sedeSeleccionada.Id,
        nombresede: sedeSeleccionada.Nombre,
        direccion: sedeSeleccionada.Direccion,
        sedeId: sedeSeleccionada.SedeId,
      })

      if (esEnviar) return

      return setServicioSeleccionado((prev) => {
        const ciudadSeleccionada = todasLasSedes.find((ciudad) => {
          return ciudad.Id === +ciudadId
        })
        return {
          ...prev,
          valorUnidad: ciudadSeleccionada?.valor,
          valorTotal: ciudadSeleccionada?.valor * (cantidadServicios || 1),
        }
      })
    }

    return setSedeSeleccionada(sedePorDefecto)
  }

  const agregarServicio = async () => {
    const servicioNoSeleccionado = !servicioSeleccionado?.nombreServicio
    const formularioLleno =
      !isValid &&
      radialSeleccionado &&
      servicioSeleccionado?.tipoServicio.toString() ===
        TIPOS_OTROS_SERVICIOS.TIQUETERA
    const sedeNoSeleccionada = !sedeSeleccionada.id && !radialSeleccionado

    if (
      servicioNoSeleccionado ||
      formularioLleno ||
      (sedeNoSeleccionada &&
        +servicioSeleccionado.tipoServicio === +TIPOS_OTROS_SERVICIOS.TIQUETERA)
    ) {
      return
    }
    const existeServicio = datosTablaServicios.find(
      (elemento) => elemento.id === servicioSeleccionado.id
    )
    if (existeServicio) {
      return
    }
    setDatosTablaServicios((prev) => [...prev, servicioSeleccionado])
    setServicioSeleccionado(servicioSeleccionadoPorDefecto)
    setCantidadServicios('')
  }

  const calcularIva = (valorTotal, valorIVA) => {
    return (valorTotal * valorIVA) / 100
  }

  const eliminarServicio = (id) => {
    const nuevoArreglo = datosTablaServicios.filter(
      (servicio) => servicio.id !== id
    )
    if (!nuevoArreglo.length) {
      setDatosTiqueteras(datosTiqueterasPorDefecto)
      reset()
      trigger()
    }
    setDatosTablaServicios(nuevoArreglo)
  }
  const columns = React.useMemo(
    () => [
      {
        Header: '',
        accessor: 'nombreServicio',
        className: 'w-8/12 text-start',
      },
      {
        Header: '',
        accessor: 'numeroDeServicios',
        className: 'w-1/12 text-13px',
      },

      {
        Header: '',
        accessor: 'valorUnidad',
        className: 'w-1/12 text-13px',
        Cell: (row) => (
          <span>{aplicarFormatoMoneda(row.row.original.valorUnidad, 0)}</span>
        ),
      },
      {
        Header: '',
        accessor: 'valorTotal',
        className: 'w-1/12 text-13px',
        Cell: (row) => (
          <span>{aplicarFormatoMoneda(row.row.original.valorTotal, 0)}</span>
        ),
      },
      {
        Header: '',
        accessor: 'iva',
        className: 'w-1/12 text-13px',
        Cell: (row) => {
          if (row.row.original.iva) {
            return <span>{`IVA ${row.row.original.iva}%`}</span>
          }
          return <span className="normal-case">No aplica</span>
        },
      },
      {
        Header: '',
        id: 'boton',
        className: 'w-1/12 -mr-10  mb-2',
        Cell: (row) => (
          <CeldaConBoton
            funcion={() => eliminarServicio(row.row.original.id)}
            imagen={BotonQuitar}
            estilosImagen="w-6 h-6"
            deshabilitado={true}
          />
        ),
      },
    ],
    [datosTablaServicios]
  )

  const agregarValoresPropiedad = (valor, nombre) => {
    setServicioSeleccionado((prev) => {
      return {
        ...prev,
        [nombre]: valor,
      }
    })
  }

  const agregarValoresTiquetera = (valor, nombre) => {
    setDatosTiqueteras((prev) => {
      return {
        ...prev,
        [nombre]: valor,
      }
    })
    if (nombre === 'ciudadId') {
      setServicioSeleccionado((prev) => {
        const ciudadSeleccionada = ciudadesRecogerEnSede.find((ciudad) => {
          return ciudad.Id === +valor
        })
        return {
          ...prev,
          valorUnidad: ciudadSeleccionada?.valor,
          valorTotal: ciudadSeleccionada?.valor * (cantidadServicios || 1),
        }
      })
    }
  }

  useEffect(() => {
    const sumatoriaServicios = datosTablaServicios
      .map((item) => parseFloat(item.valorTotal))
      .reduce((prev, curr) => prev + curr, 0)
      .toFixed(2)

    const valorIva = datosTablaServicios
      .reduce((prev, curr) => prev + parseFloat(curr.ivaCalculado), 0)
      .toFixed(2)

    const total = parseFloat(sumatoriaServicios) + parseFloat(valorIva)

    setValoresTabla({
      totalServicios: sumatoriaServicios,
      totalIva: valorIva,
      totalTransaccion: total,
    })
  }, [datosTablaServicios.length, servicioSeleccionado?.numeroDeServicios])

  const validarExistenciaTiqueterasCarrito = () => {
    return Boolean(
      datosTablaServicios?.find(
        (elemento) =>
          elemento?.tipoServicio === +TIPOS_OTROS_SERVICIOS.TIQUETERA
      )
    )
  }

  return (
    <>
      <ContenedorTituloResaltado
        titulo={'AGREGAR SERVICIOS AL CARRITO'}
        activarBorde={false}
        imagen={IconoAgregarAlCarrito}
      >
        <div className="w-full flex items-center justify-center ">
          <ListaDesplegable
            estilosContenedor={'w-8/12'}
            estilosLista={`rounded relative block w-full p-1.5 border text-cendiatra-gris-3 border-cendiatra rounded-lg focus:outline-none  sm:text-sm border`}
            titulo={'Servicio'}
            opciones={listaDeServicios}
            valor={servicioSeleccionado.id}
            onChange={(e) => manejarExamenSeleccionado(e.target.value)}
          />
          <NumeroConTitulo
            titulo={'Cantidad'}
            formatoMoneda={false}
            estilosContenedor={'w-1/12 mt-2'}
            estilosAdicionales={`w-12 h-10 border border-cendiatra rounded focus:outline-none mx-5 ${
              servicioSeleccionado?.nombreServicio
                ? ''
                : 'bg-cendiatra-gris-2 text-white pointer-events-none placeholder-white'
            }`}
            funcion={manejarCantidadDeServicios}
            valor={cantidadServicios}
          />
          <NumeroConTitulo
            titulo={'Valor Unidad'}
            estilosContenedor={'w-1/12 mt-2'}
            estilosAdicionales={
              'w-12 h-10 focus:outline-none pointer-events-none'
            }
            valor={servicioSeleccionado?.valorUnidad}
          />
          <NumeroConTitulo
            titulo={'Valor Total'}
            estilosContenedor={'w-1/12 mt-2'}
            estilosAdicionales={
              'w-12 h-10 focus:outline-none pointer-events-none'
            }
            valor={servicioSeleccionado?.valorTotal}
          />
          <NumeroConTitulo
            titulo={'Aplica IVA'}
            estilosContenedor="w-1/12 mt-2"
            estilosAdicionales="w-12 h-10 pointer-events-none"
            formatoMoneda={false}
            valor={
              servicioSeleccionado?.iva
                ? `IVA ${servicioSeleccionado?.iva}%`
                : ''
            }
            placeholder={''}
          />
          <BotonConImagen
            estilosContenedor={'mt-5 -mr-10 w-1/12'}
            ancho={'w-full flex justify-center items-center '}
            imagen={BotonAgregar}
            textoAlternativo={'Agregar'}
            funcionAEjecutar={agregarServicio}
          />
        </div>
        <div
          className={clsx('w-full items-center justify-center mt-3', {
            flex:
              servicioSeleccionado?.tipoServicio ===
                +TIPOS_OTROS_SERVICIOS.TIQUETERA &&
              !validarExistenciaTiqueterasCarrito(),
            hidden:
              servicioSeleccionado?.tipoServicio !==
                +TIPOS_OTROS_SERVICIOS.TIQUETERA ||
              validarExistenciaTiqueterasCarrito(),
          })}
        >
          <div className="w-8/12"></div>
          <div className="w-4/12 text-cendiatra-rojo-1">
            Seleccione una ciudad en los datos de envío para ver el precio.
          </div>
        </div>
      </ContenedorTituloResaltado>
      {(servicioSeleccionado?.tipoServicio ===
        +TIPOS_OTROS_SERVICIOS.TIQUETERA ||
        validarExistenciaTiqueterasCarrito()) &&
      (ciudadesEnviarADomicilio.length || ciudadesRecogerEnSede.length) ? (
        <ContenedorTituloResaltado
          titulo={'DATOS DE ENVÍO PARA TIQUETERAS'}
          activarBorde={false}
        >
          <div className="w-full flex items-center justify-start my-2 flex-wrap">
            {ciudadesEnviarADomicilio.length ? (
              <div className="w-2/12 flex justify-start items-center">
                <LeyendaConInputRadio
                  titulo={'Enviar a domicilio'}
                  seleccionado={radialSeleccionado}
                  funcion={cambiarInputRadial}
                  estilosTexto={clsx({
                    'text-cendiatra-gris-2 pointer-events-none':
                      validarExistenciaTiqueterasCarrito() &&
                      !radialSeleccionado,
                    'text-cendiatra-verde-2': !(
                      validarExistenciaTiqueterasCarrito() &&
                      !radialSeleccionado
                    ),
                  })}
                />
              </div>
            ) : null}
            {ciudadesRecogerEnSede.length ? (
              <div className="w-2/12 flex justify-start items-center">
                <LeyendaConInputRadio
                  titulo={'Recoger en sede'}
                  seleccionado={!radialSeleccionado}
                  funcion={cambiarInputRadial}
                  estilosTexto={clsx({
                    'text-cendiatra-gris-2 pointer-events-none':
                      validarExistenciaTiqueterasCarrito() &&
                      radialSeleccionado,
                    'text-cendiatra-verde-2': !(
                      validarExistenciaTiqueterasCarrito() && radialSeleccionado
                    ),
                  })}
                />
              </div>
            ) : null}
            {radialSeleccionado ? (
              <div className="w-8/12 text-cendiatra-rojo-1">
                Estimado cliente, solo tenemos disponibilidad de domicilio en
                las ciudades de {nombreCiudades.join(', ')}.
              </div>
            ) : null}

            <div
              className={`w-full  items-center justify-start my-5 ${
                radialSeleccionado ? 'flex' : 'hidden'
              }`}
            >
              <Controller
                name="nombreDeQuienRecibe"
                control={control}
                rules={{
                  required: true,
                  onChange: (e) =>
                    agregarValoresTiquetera(e.target.value, e.target.name),
                }}
                render={({
                  field: {name, value, onChange},
                  fieldState: {error},
                }) => (
                  <Input
                    estilosContenedor="w-15% mr-5"
                    estilosInput={clsx(
                      'rounded relative block w-full p-1.5 border text-cendiatra-gris-3 rounded-lg focus:outline-none sm:text-sm',
                      {
                        'border-cendiatra': !error,
                        'border-cendiatra-rojo-1': error,
                      }
                    )}
                    mostrarErrores={true}
                    tipo="text"
                    nombre={name}
                    titulo={'Nombre de quien recibe'}
                    valor={value}
                    onChange={onChange}
                  />
                )}
              />
              <Controller
                name="ciudadId"
                control={control}
                rules={{
                  required: true,
                  onChange: (e) =>
                    manejarSedeSeleccionada(e.target.value, true),
                }}
                render={({
                  field: {name, value, onChange},
                  fieldState: {error},
                }) => (
                  <ListaDesplegable
                    funcion={null}
                    estilosContenedor="w-15% mr-5"
                    estilosLista={clsx(
                      'rounded relative block w-full p-1.5 border text-cendiatra-gris-3 rounded-lg focus:outline-none sm:text-sm',
                      {
                        'border-cendiatra': !error,
                        'border-cendiatra-rojo-1': error,
                        'bg-cendiatra-gris-2 pointer-events-none text-white':
                          validarExistenciaTiqueterasCarrito(),
                      }
                    )}
                    nombre={name}
                    titulo={'Ciudad'}
                    opciones={ciudadesEnviarADomicilio}
                    valor={value}
                    onChange={onChange}
                    tabIndex={'-1'}
                  />
                )}
              />
              <Controller
                name="barrio"
                control={control}
                rules={{
                  required: true,
                  onChange: (e) =>
                    agregarValoresTiquetera(e.target.value, e.target.name),
                }}
                render={({
                  field: {name, value, onChange},
                  fieldState: {error},
                }) => (
                  <Input
                    estilosContenedor="w-15% mr-5"
                    estilosInput={clsx(
                      'rounded relative block w-full p-1.5 border text-cendiatra-gris-3 rounded-lg focus:outline-none sm:text-sm',
                      {
                        'border-cendiatra': !error,
                        'border-cendiatra-rojo-1': error,
                      }
                    )}
                    mostrarErrores={true}
                    tipo="text"
                    nombre={name}
                    titulo={'Barrio'}
                    valor={value}
                    onChange={onChange}
                  />
                )}
              />
              <Controller
                name="direccion"
                control={control}
                rules={{
                  required: true,
                  onChange: (e) =>
                    agregarValoresTiquetera(e.target.value, e.target.name),
                }}
                render={({
                  field: {name, onChange, value},
                  fieldState: {error},
                }) => (
                  <Input
                    estilosContenedor="w-15% mr-5"
                    estilosInput={clsx(
                      'rounded relative block w-full p-1.5 border text-cendiatra-gris-3 rounded-lg focus:outline-none sm:text-sm',
                      {
                        'border-cendiatra': !error,
                        'border-cendiatra-rojo-1': error,
                      }
                    )}
                    mostrarErrores={true}
                    tipo="text"
                    nombre={name}
                    titulo={'Dirección a entregar'}
                    valor={value}
                    onChange={onChange}
                  />
                )}
              />
              <Controller
                name="telefono"
                control={control}
                rules={{
                  required: true,
                  pattern: appRegex.numeros,
                  onChange: (e) =>
                    agregarValoresTiquetera(e.target.value, e.target.name),
                }}
                render={({
                  field: {name, onChange, value},
                  fieldState: {error},
                }) => (
                  <Input
                    estilosContenedor="w-15% mr-5"
                    estilosInput={clsx(
                      'rounded relative block w-full p-1.5 border text-cendiatra-gris-3 rounded-lg focus:outline-none sm:text-sm',
                      {
                        'border-cendiatra': !error,
                        'border-cendiatra-rojo-1': error,
                      }
                    )}
                    mostrarErrores={true}
                    tipo="text"
                    nombre={name}
                    titulo={'Teléfono'}
                    valor={value}
                    onChange={onChange}
                  />
                )}
              />
            </div>

            <div
              className={`w-full ${
                !radialSeleccionado ? 'flex' : 'hidden'
              } items-center justify-start my-5`}
            >
              <div className="w-2/12 flex justify-start items-center">
                <ListaDesplegable
                  estilosContenedor="w-full mr-5"
                  estilosLista={clsx(
                    'rounded relative block w-full p-1.5 border text-cendiatra-gris-3 rounded-lg focus:outline-none border border-cendiatra',
                    {
                      'border-cendiatra': sedeSeleccionada?.id,
                      'border-cendiatra-rojo-1': !sedeSeleccionada?.id,
                      'bg-cendiatra-gris-2 pointer-events-none text-white':
                        validarExistenciaTiqueterasCarrito(),
                    }
                  )}
                  titulo={'Ciudad donde recoger'}
                  opciones={ciudadesRecogerEnSede}
                  valor={sedeSeleccionada?.id || 0}
                  nombre={'sedeParaRecoger'}
                  onChange={(e) => manejarSedeSeleccionada(e.target.value)}
                  tabIndex={'-1'}
                />
              </div>
              <div className="w-5/12 flex justify-start items-center flex-wrap mt-1">
                <span className="w-full text-cendiatra mb-1">
                  Dirección donde recoger
                </span>
                <span className="w-full text-cendiatra-gris-1 py-1.5 text-md">
                  {sedeSeleccionada?.direccion}
                </span>
              </div>
            </div>
            <div className="w-5/12">
              <AlertaDinamica
                mostrarAlerta={validarExistenciaTiqueterasCarrito()}
                mensaje={
                  'SÍ DESEA CAMBIAR LA CIUDAD O LA MODALIDAD DE ENVÍO, DEBE ELIMINAR TODAS LAS TIQUETERAS DEL CARRITO'
                }
              />
            </div>
            <span className="w-full text-center text-cendiatra-rojo-1 text-lg -mb-3 mt-5">
              Los datos de envío registrados serán utilizados para todas las
              tiqueteras en el carrito.
            </span>
          </div>
        </ContenedorTituloResaltado>
      ) : null}

      <ContenedorTituloResaltado
        titulo={'SERVICIOS EN EL CARRITO'}
        activarBorde={false}
        imagen={IconoServicioEnCarrito}
      >
        <div className="w-full flex items-center justify-center -mt-14">
          <TablaDinamica
            columns={columns}
            data={datosTablaServicios}
            fondoTabla={'hidden h-1'}
          />
        </div>

        <div className="w-full flex justify-between items-center mt-10">
          <div className="w-8/12"></div>
          <div className="w-4/12 flex justify-end items-center flex-wrap">
            {datosTablaServicios.length ? (
              <>
                <span className="w-6/12 text-cendiatra items-center justify-center text-lg font-bold">
                  Servicios{' '}
                </span>
                <span className="w-3/12 text-cendiatra items-center justify-center text-lg font-bold text-end">
                  {' '}
                  {aplicarFormatoMoneda(valoresTabla?.totalServicios)}{' '}
                </span>
                <span className="w-6/12 text-cendiatra items-center justify-center text-lg font-bold">
                  IVA 19%
                </span>
                <span className="w-3/12 text-cendiatra items-center justify-center text-lg font-bold text-end">
                  {aplicarFormatoMoneda(valoresTabla?.totalIva)}{' '}
                </span>
              </>
            ) : null}

            <span className="w-4/12 text-cendiatra items-center justify-center text-2xl font-extrabold mt-5 ">
              TOTAL
            </span>
            <span className="w-5/12 text-cendiatra text-end items-center justify-center text-2xl font-extrabold mt-5 ">
              {aplicarFormatoMoneda(valoresTabla?.totalTransaccion)}
            </span>
          </div>
        </div>

        <div className="w-full flex justify-center items-center mt-10">
          <BotonSimple
            texto={'Continuar'}
            estilosBoton={clsx(
              'w-28 h-10 text-white bg-center bg-cover bg-no-repeat rounded-lg text-14px m-2',
              {
                'bg-fondoBoton': datosTablaServicios.length,
                'bg-cendiatra-gris-placeholder pointer-events-none':
                  !datosTablaServicios.length,
              }
            )}
            funcion={() =>
              funcionCambiarDePantalla(
                valoresTabla,
                datosTablaServicios,
                datosTiqueteras,
                sedeSeleccionada
              )
            }
            tipoDeBoton={'button'}
          />
        </div>
      </ContenedorTituloResaltado>
    </>
  )
}

export default PagarOtrosServicios
